import axios from "axios";
import { NotImplementedError } from "../../errors";
import { UXConfigHandler } from "../../handlers/ux";
import { parseIdFilter } from "../../handlers/filter";
class Values extends UXConfigHandler {
    constructor(sdk) {
        super(sdk, "values");
    }
    /**
     * Currently we don't need to support filtering on the find
     * @returns
     */
    async findItems(filters) {
        const idFilter = parseIdFilter(filters);
        const promise = idFilter.size === 1
            ? this.getValueProperty(idFilter.values().next().value).then((valueProperty) => [
                valueProperty
            ])
            : this.getValueProperties();
        return await promise;
    }
    getValueProperty(id) {
        return this.cache.promise(id, () => axios
            .get(`${this.sdk.urls.baseAPIUrl}/ux/value-property/${id}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
            // API is returning an array for single item requests.
            .then((res) => res.data?.data?.[0]));
    }
    getValueProperties() {
        const url = `${this.sdk.urls.baseAPIUrl}/ux/value-properties`;
        return this.cache.promise(url, () => axios
            .get(url, {
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then((res) => res.data.data || []));
    }
    /**
     * API to save values takes an array of partial or full values and will update/create them
     * @param valueData The value data to update
     * @returns Promise that will resolve with the created/updated value
     */
    async saveItem(valueData) {
        return axios
            .post(`${this.sdk.urls.baseAPIUrl}/ux/value-properties`, [valueData], {
            headers: { "Content-Type": "application/json" }
        })
            .then((saved) => {
            return saved.data.data[0];
        });
    }
    async deleteItem() {
        throw new NotImplementedError("delete");
    }
}
export default Values;
//# sourceMappingURL=values.js.map